"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
var types_1 = require("../../types");
var isOneOfPages_1 = __importDefault(require("../isOneOfPages"));
function getSportEventTypesByLocation() {
    if (isOneOfPages_1.default(constants_1.pages.outright)) {
        return [types_1.GQL.SportEventType.OUTRIGHT];
    }
    return [types_1.GQL.SportEventType.MATCH];
}
exports.default = getSportEventTypesByLocation;
//# sourceMappingURL=getSportEventTypesByLocation.js.map